import { useVideoPlatform } from '../../hooks/useVideoPlatform';
import { ScreenShareMenuItemsWrapper as ScreenShareMenuItems } from '../../session/controls/ScreenShareControl';
import { WhiteboardControlMenuItemWrapper as WhiteboardControlMenuItem } from '../../session/controls/WhiteboardControl';
import { VideoPlatform } from '../../video-sdk';

export function SessionModeControlMenuItemsWrapper() {
  const videoPlatformIsZoom = useVideoPlatform() === VideoPlatform.Zoom;

  // Whiteboarding is not scoped for the initial Zoom launch, but will be added
  // later.
  if (videoPlatformIsZoom) {
    return <ScreenShareMenuItems />;
  }

  return (
    <>
      <ScreenShareMenuItems />
      <WhiteboardControlMenuItem />
    </>
  );
}
